import {
  Box,
  Typography,
  TextField,
  CircularProgress,
  InputAdornment,
  IconButton,
  FormHelperText,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import TreffasStyle from "src/utils/TreffasStyle";
import { StaticDatePicker } from "@mui/x-date-pickers";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Timezone from "src/utils/Timezone";
import StepperGuide from "src/components/StepperGuide";
import TreffasTextField from "src/components/TreffasTextField";
import { ArrowDropDown } from "@mui/icons-material";
import TimezonePicker from "src/views/general/timezone-picker";
import RenderTimeSlots from "src/views/general/booking-components/RenderTimeSlots";
import NoAvailableTime from "src/views/general/booking-components/NoAvailableTime";
import { useFacebookPixelPublic } from "src/views/hooks/useFacebookPixelPublic";
import { useGoogleAnalyticsPublic } from "src/views/hooks/useGoogleAnalyticsPublic";
import { useDateAndTimePicker } from "src/views/hooks/useDateAndTimePicker";

const DateAndTime = ({
  errors,
  setSelectedTimezone,
  selectedTimezone,
  sessionList,
  selectedSessionTime,
  setSessionSelectedTime,
  selectedOffer,
  setSessionList,
  selectedDate,
  setSelectedDate,
  setError,
  clearErrors,
  nextButtonRef,
  calendarMaxDate,
  userdateFormat,
  userTimeFormat,
  userMinimumBookingNotice,
  stepperGuideLength,
  coachDetails,
  setOverFlowTimeToRender,
  setUnderFlowTimeToRender,
  isUseTimeRecord,
  setIsUseTimeRecord,
  timeRecords,
  setTimeRecords,
  setAllUpcommingAppt,
  customStyle,
}) => {
  const { t } = useTranslation();
  const { userId, offerId, organizationId } = useParams();
  const [rerenderPixel] = useState(1);
  const {
    filteredList,
    preparingSessionList,
    timezoneDialog,
    isTimezoneChange,
    timeHover,
    setTimeHover,
    shouldDisabledDate,
    handleSelectedDate,
    handleTimezoneChange,
    handleSelectedTime,
    handleMonthChange,
    openTimezoneDialog,
    closeTimezoneDialog,
    datePickerMinDate,
    datePickerMaxDate,
    pickerValue,
  } = useDateAndTimePicker({
    selectedOffer,
    coachDetails,
    selectedTimezone,
    selectedDate,
    setSelectedDate,
    setSelectedTimezone,
    sessionList,
    setSessionList,
    setSessionSelectedTime,
    setOverFlowTimeToRender,
    setUnderFlowTimeToRender,
    setAllUpcommingAppt,
    isUseTimeRecord,
    setIsUseTimeRecord,
    timeRecords,
    setTimeRecords,
    clearErrors,
    calendarMaxDate,
    offerId,
    userId,
    organizationId,
    userDateFormat: userdateFormat,
    userTimeFormat,
    userMinimumBookingNotice,
    nextButtonRef,
    setError,
  });

  const user_settings = coachDetails?.settings
    ? JSON.parse(coachDetails?.settings)
    : null;
  const __analytics = user_settings?.analytics ?? null;
  let enable = __analytics?.has_meta_pixel ?? false;
  let pixelId = __analytics?.meta_pixel ?? null;
  let googleAnalyticsEnable = __analytics?.has_google_analytics ?? false;
  let gaId = __analytics?.google_analytics ?? null;

  const trackEventInFacebook = useFacebookPixelPublic({
    track: "ViewContent",
    content_name: `${selectedOffer?.name ?? ""} Create booking url`,
    content_description: `${
      selectedOffer?.description ?? "Package create booking url."
    }`,
    enable: enable,
    pixelId: pixelId,
  });

  const trackEventInGoogleAnalytics = useGoogleAnalyticsPublic({
    enable: googleAnalyticsEnable,
    gaId: gaId,
  });

  useEffect(() => {
    trackEventInFacebook();
    trackEventInGoogleAnalytics("view_content", {
      content_name: `${selectedOffer?.name ?? ""} Create booking url`,
      content_description: `${
        selectedOffer?.description ?? "Package create booking url."
      }`,
    });
  }, [rerenderPixel]);

  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            pt: "58px",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontFamily:
                  customStyle.headingFont ?? "var(--font-grenettepromedium)",
                fontSize: "18px",
                lineHeight: "31px",
                alignItems: "center",
                color: customStyle.textColor ?? "#060A2D",
              }}
            >
              {t("individual.booking.schedule.choose_schedule")}
            </Typography>

            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "18px",
                color: customStyle.secondaryTextColor ?? "#878787",
                fontFamily: customStyle.bodyFont ?? "karla",
                mt: "4px",
              }}
            >
              {t("individual.booking.schedule.choose_schedule.description", {
                package: selectedOffer?.name,
              })}
            </Typography>
          </Box>

          <Box>
            <StepperGuide
              length={stepperGuideLength}
              activeLength={[1]}
              customStyle={customStyle}
            />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          mt: "48px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: { xs: "10px", md: "32px" },
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box className="new-static-calendar hide-selected-button">
            <StaticDatePicker
              // disablePast
              minDate={datePickerMinDate}
              displayStaticWrapperAs="desktop"
              value={pickerValue}
              shouldDisableDate={shouldDisabledDate}
              onChange={handleSelectedDate}
              onMonthChange={handleMonthChange}
              renderInput={(params) => <TextField {...params} />}
              views={["day"]}
              inputFormat={userdateFormat}
              maxDate={datePickerMaxDate}
              showDaysOutsideCurrentMonth
            />
          </Box>

          {/* availabitlity */}
          <Box
            style={{
              width: "100%",
            }}
          >
            <Box mb={"20px"}>
              <Box mb={"10px"}>
                <Typography
                  sx={{
                    fontFamily:
                      customStyle.headingFont ??
                      "var(--font-grenettepromedium)",
                    fontSize: "10px",
                    lineHeight: "11px",
                    letterSpacing: "0.07em",
                    color: customStyle.secondaryTextColor ?? "#A1A1A1",
                    textTransform: "uppercase",
                  }}
                >
                  {t("booking.label.select_timezone")}
                </Typography>
              </Box>

              <Box sx={{ px: "5px" }}>
                <Box>
                  <TreffasTextField
                    value={Timezone.getLabel(selectedTimezone) ?? ""}
                    sx={TreffasStyle.formInputLarge("autocomplete")}
                    placeholder={t("booking.placeholder.select_timezone")}
                    fullWidth
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            size={"small"}
                            onClick={() => openTimezoneDialog()}
                          >
                            <ArrowDropDown />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <Box>
                    <TimezonePicker
                      dialog={timezoneDialog}
                      close={closeTimezoneDialog}
                      selectedTimezone={selectedTimezone}
                      onChange={handleTimezoneChange}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box>
              <Box mb={"10px"}>
                <Typography
                  sx={{
                    fontFamily:
                      customStyle.headingFont ??
                      "var(--font-grenettepromedium)",
                    fontSize: "10px",
                    lineHeight: "11px",
                    letterSpacing: "0.07em",
                    color: customStyle.secondaryTextColor ?? "#878787",
                    textTransform: "uppercase",
                  }}
                >
                  {t("booking.placeholder.time_slots")}
                </Typography>

                {Boolean(errors?.time) && (
                  <FormHelperText error>
                    {" "}
                    {errors?.time?.message}{" "}
                  </FormHelperText>
                )}
              </Box>

              {selectedDate === null || selectedDate === "" ? (
                <NoAvailableTime
                  message={t("booking.error.required.select_date")}
                />
              ) : (
                <Box
                  className="session-time-scroll"
                  sx={{
                    height: "338px",
                    overflowY: "auto",
                    width: "392px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                    }}
                  >
                    {preparingSessionList ? (
                      <Box
                        sx={{
                          width: "100%",
                          textAlign: "center",
                          mt: "10px",
                        }}
                      >
                        <CircularProgress size={20} />
                      </Box>
                    ) : filteredList?.length > 0 ? (
                      filteredList?.map((time, key) => {
                        return (
                          <Box
                            sx={{
                              width: "119px",
                            }}
                            key={key}
                          >
                            <RenderTimeSlots
                              selectedSessionTime={selectedSessionTime}
                              time={time}
                              handleSelectedTime={handleSelectedTime}
                              timeHover={timeHover}
                              setTimeHover={setTimeHover}
                              userTimeFormat={userTimeFormat}
                              _key={key}
                              customStyle={customStyle}
                            />
                          </Box>
                        );
                      })
                    ) : (
                      <NoAvailableTime
                        message={
                          isTimezoneChange
                            ? t(
                                "individual.booking.schedule.choose_schedule.select_date_again"
                              )
                            : t(
                                "booking.error.required.no_time_on_selected_date"
                              )
                        }
                      />
                    )}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DateAndTime;
